export { default as FontsProvider } from './FontsProvider'
